export default {
	er_cover_default_title: 'Огляд ефективності',
	er_page_success_metrics: 'Що змінилось цього місяця',
	er_page_success_metrics_range: 'Що змінилось за цей період',
	er_page_success_metrics_week: 'Що змінилось цього тижня',
	er_page_comparison: 'Порівняльний підсумок',
	er_page_period_summary: 'Підсумок місяця',
	er_page_period_summary_range: 'Підсумок періоду',
	er_page_period_summary_week: 'Підсумок тижня',
	er_page_each_month: 'Кожен місяць',
	er_page_rooms: 'Приміщення',
	er_rooms_note: 'Кожне приміщення у {month}, найкращий бал зверху.',
	er_page_shift_comparison: 'Порівняння за змінами',
	er_page_shift_summary: 'За змінами',
	er_page_response_time: 'Середній час реакції (хв)',
	er_page_avg_score: 'Оцінка враження',
	er_page_complaints_vs_visits: 'Скарги проти візитів',
	er_page_performance_trends: 'Динаміка показників',
	er_page_complaint_drivers: 'Причини скарг',

	er_board_working: 'Краще, ніж {month}',
	er_board_attention: 'Потребує уваги щодо {month}',
	er_board_empty: 'Цього місяця немає суттєвих змін.',
	er_board_empty_range: 'За цей період немає суттєвих змін.',
	er_board_empty_week: 'Цього тижня немає суттєвих змін.',
	er_findings_intro: 'Порівняння з {month}. Показано лише суттєві зміни.',
	er_verdict_improved: 'Покращення',
	er_verdict_watch: 'Потребує уваги',

	er_col_metric: 'Показник',
	er_col_avg: 'Сер. YTD',
	er_col_lifetime_avg: 'Сер. з початку роботи',
	er_comparison_note: 'Сер. YTD — показник з січня по {month}.',
	er_lifetime_note: 'З початку роботи — середньомісячне значення з першого дня з даними до {month}.',
	er_comparison_note_week: 'Тиждень звіту порівнюється з вибраним попереднім тижнем.',
	er_period_only_note: 'Показники лише за {month}.',
	er_each_month_note: 'Кожен місяць обраного періоду. Місяць без даних залишається порожнім.',
	er_col_inc_dec: 'Зміна',
	er_col_complaint: 'Скарга',
	er_col_qty: 'К-сть',
	er_total: 'Разом',

	er_metric_avg_score: 'Оцінка враження',
	er_metric_avg_response_time: 'Середній час реакції',
	er_metric_cleaner_arrivals: 'Приходи клінерів',
	er_metric_supervisor_inspections: 'Перевірки супервайзерів',
	er_metric_complaints_vs_visits_pct: 'Скарги до відвідувань (%)',
	er_metric_complaints: 'Скарги',
	er_metric_customer_visits: 'Візити',
	er_metric_expired_slas: 'Прострочені SLA',
	er_unit_min: 'хв',
	er_stat_expected_sla: 'Очікуваний SLA',
	er_stat_vs_minutes: 'до {value} у {month}',
	er_stat_vs_count: 'до {value} у {month}',
	er_label_complaints: 'Скарги',
	er_label_visits: 'Відвідування',
	er_label_complaints_per_visits: 'Скарги / відвідування',
	er_chart_ratio: 'Частка скарг до відвідувань',
	er_chart_ytd_window: 'Із січня по {month}.',
	er_cv_formula: 'Скарги, поділені на відвідування вбиралень, у відсотках: ({complaints} ÷ {visits}) × 100 = {ratio}% у {month}.',
	er_export_kpis_title: 'Що входить до звіту',
	er_export_kpis_desc: 'Усе це є у звіті. Вимкніть показник, щоб прибрати його.',
	er_export_select_all: 'Вибрати все',
	er_export_clear_all: 'Зняти все',
	er_export_summary: '{report} vs {compare}',
	er_export_period_title: 'Період звіту',
	er_export_grain: 'Звіт за',
	er_export_grain_month: 'Місяць',
	er_export_grain_week: 'Тиждень',
	er_export_week_starts: 'Тиждень починається в',
	er_export_week_starts_sunday: 'неділю',
	er_export_week_starts_monday: 'понеділок',
	er_export_report_month: 'Місяць звіту',
	er_export_from_month: 'З місяця',
	er_export_to_month: 'До місяця',
	er_export_period_note_range: 'Звіт підсумовує кожен місяць від початку до кінця. Коли порівняння увімкнено, береться попередній період тієї самої тривалості. Показники з початку року й далі рахуються від січня до кінцевого місяця.',
	er_export_summary_range: '{from} – {to}',
	er_export_summary_range_vs: '{from} – {to} проти {compare}',
	er_export_compare_range_note: 'Попередній період тієї самої тривалості.',
	er_export_report_week: 'Тиждень звіту',
	er_export_compare_month: 'Порівняти з',
	er_export_shift: 'Зміна',
	er_export_shift_all: 'Усі зміни',
	er_export_no_shifts: 'На цьому об’єкті немає активних змін.',
	er_export_render_failed: 'Не вдалося правильно сформувати звіт, тому його не завантажено. Оновіть сторінку та спробуйте ще раз.',
	er_export_comparison: 'Порівняння',
	er_export_include_previous: 'Включити попередній період',
	er_export_comparison_on: 'Увімк.',
	er_export_comparison_off: 'Вимк.',
	er_export_no_previous_data: 'До цього періоду немає даних, тому порівнювати немає з чим.',
	er_export_compare_previous: 'Попередній місяць',
	er_export_compare_previous_week: 'Попередній тиждень',
	er_export_compare_last_year: 'Той самий місяць торік',
	er_export_no_periods: 'Для експорту звіту на об’єкті потрібен щонайменше один місяць даних.',
	er_export_no_periods_week: 'Для експорту звіту на об’єкті потрібен щонайменше один тиждень даних.',
	er_export_period_note: 'Показано лише місяці з даними. Показники з початку року завжди охоплюють січень — місяць звіту.',
	er_export_period_note_week: 'Показано лише тижні з даними. Порівняння завжди з ранішим тижнем.',
	er_export_period_note_single_week: 'Показано лише тижні з даними.',

	er_find_response_time_title: 'Середній час реакції',
	er_find_response_time_change:
		'Змінився з {previous} до {current} хв ({change}).',
	er_find_avg_score_title: 'Оцінка враження',
	er_find_score_eased: 'Знизився з {previous} до {current}.',
	er_find_score_improved: 'Зріс з {previous} до {current}.',
	er_find_score_ytd_inline: 'Збігається із середнім з початку року ({ytd}).',
	er_find_score_ytd_inline_range: 'Збігається із середнім із січня по {endMonth} ({ytd}).',
	er_find_score_ytd_against: 'Середнє з початку року: {ytd}.',
	er_find_score_ytd_against_range: 'Середнє з січня по {endMonth}: {ytd}.',
	er_find_complaints_ratio_title: 'Частка скарг до відвідувань',
	er_find_complaints_ratio_improved: 'Покращився з {previous} до {current}.',
	er_find_complaints_ratio_rose: 'Змінився з {previous} до {current}.',

	er_nar_cv_year_improved: 'Скарги відносно відвідувань вбиралень покращилися з {from} до {to} протягом року.',
	er_nar_cv_year_rose: 'Скарги відносно відвідувань вбиралень зросли з {from} до {to} протягом року.',
	er_nar_cv_moved: 'Скарги відносно відвідувань вбиралень змінилися з {previous} до {current}.',
	er_nar_cv_current: 'Скарги відносно відвідувань вбиралень становлять {current}.',
	er_nar_types_total: 'Усього скарг {total}.',
	er_nar_types_1: 'Головна скарга: {a} ({ap}%).',
	er_nar_types_2: 'Головна скарга: {a} ({ap}%), потім {b} ({bp}%).',
	er_nar_types_3: 'Головна скарга: {a} ({ap}%), потім {b} ({bp}%) і {c} ({cp}%).',
	er_find_rooms_slowest: 'Приміщення з найдовшим часом реакції цього місяця: {rooms}.',
	er_find_rooms_slowest_range: 'Приміщення з найдовшим часом реакції за цей період: {rooms}.',
	er_find_rooms_slowest_week: 'Приміщення з найдовшим часом реакції цього тижня: {rooms}.',
	er_find_rooms_lowest_score: 'Приміщення з найнижчою оцінкою цього місяця: {rooms}.',
	er_find_rooms_lowest_score_range: 'Приміщення з найнижчою оцінкою за цей період: {rooms}.',
	er_find_rooms_lowest_score_week: 'Приміщення з найнижчою оцінкою цього тижня: {rooms}.',

	er_find_so_what_ratio: 'Більшість зміни припала на {rooms}.',
	er_find_so_what_type: 'Основна скарга: {name} ({percent}%).',
	er_hot_slowest: 'Приміщення з найдовшим часом реакції',
	er_hot_expired_slas: 'Приміщення, що перевищили SLA',
	er_hot_ratio: 'Приміщення з найбільшою зміною частки скарг',
	er_hot_top_type: 'Приміщення з найбільшою кількістю скарг «{name}»',
	er_hot_col_room: 'Приміщення',
	er_col_response: 'Реакція',
	er_col_cleaners: 'Прибирання',
	er_col_score: 'Бал',
	er_chart_sla: 'SLA',
	er_hot_col_ratio: 'Частка',
	er_hot_col_change: 'Зміна',
	er_hot_col_count: 'К-сть',
	er_hot_empty: 'Немає помітних приміщень цього місяця.',
	er_hot_empty_range: 'Немає помітних приміщень за цей період.',
	er_hot_empty_week: 'Немає помітних приміщень цього тижня.',
	er_cover_highlights: 'Цього місяця',
	er_cover_highlights_range: 'Цей період',
	er_cover_highlights_week: 'Цього тижня',
	er_cover_score_rose: 'Оцінка враження зросла.',
	er_cover_score_eased: 'Оцінка враження знизилась.',
	er_cover_response_improved: 'Час реакції покращився.',
	er_cover_response_slowed: 'Час реакції збільшився.',
	er_cover_ratio_fell: 'Співвідношення скарг до візитів знизилось.',
	er_cover_ratio_rose: 'Співвідношення скарг до візитів зросло.',
	er_export_pdf: 'PDF панелі',
	er_export_executive: 'Виконавчий звіт',
	'executive-report': 'Виконавчий звіт',
	er_export_csv: 'CSV',
	er_export_status_title: 'Створюємо звіт',
	er_export_status_fetch: 'Завантажуємо цифри',
	er_export_status_layout: 'Верстаємо сторінки',
	er_export_status_page: 'Сторінка {page} з {total}',
	er_footer_copyright: 'Цей звіт сформовано системою BuzzzTech.',
	er_contact_line: 'Є запитання або хочете глибше розібрати дані? Зверніться до команди Customer Success BuzzzTech: {email} або {phone}.',
};
